import { money } from "../utils/formatters";

/**
 * Vista simplificada para modo empresa (solo balance y clientes)
 */
export default function EmpresaSimpleView({ resumen }) {
    return (
        <div className="p-2">
            {/* Balance destacado */}
            <div
                className={`rounded-md border p-2 hover:shadow-sm transition-all ${(resumen.balance ?? 0) >= 0
                        ? "border-emerald-200 bg-gradient-to-br from-emerald-50 to-green-50"
                        : "border-red-200 bg-gradient-to-br from-red-50 to-pink-50"
                    }`}
            >
                <div className="flex items-center gap-1.5 mb-1.5">
                    <span className="text-sm leading-none">💼</span>
                    <p
                        className={`text-[10px] font-bold uppercase tracking-wider ${(resumen.balance ?? 0) >= 0 ? "text-emerald-700" : "text-red-700"
                            }`}
                    >
                        BALANCE
                    </p>
                </div>
                <div
                    className={`text-lg font-semibold leading-tight ${(resumen.balance ?? 0) >= 0 ? "text-emerald-800" : "text-red-800"
                        }`}
                >
                    {money(resumen.balance)}
                </div>
            </div>

            {/* Lista de clientes */}
            <div className="mt-3">
                <div className="text-[10px] font-semibold uppercase text-slate-500 mb-2 flex items-center gap-2">
                    <span className="text-sm leading-none">👥</span>
                    Clientes de la empresa
                    <span className="ml-1 text-slate-400">({(resumen.clientes || []).length})</span>
                </div>

                {(resumen.clientes || []).length ? (
                    <ul className="divide-y divide-slate-100 rounded-lg border border-slate-200 bg-white/70">
                        {(resumen.clientes || []).map((c) => (
                            <li
                                key={c.id}
                                className="flex items-center justify-between p-2 hover:bg-slate-50 transition-colors"
                            >
                                <div className="flex items-center gap-2">
                                    <span className="text-base">🏷️</span>
                                    <span className="font-medium text-slate-800 text-xs">{c.nombre}</span>
                                </div>
                                <div className="text-[11px] text-slate-600">
                                    Depósito:{" "}
                                    <span className="bg-indigo-100 text-indigo-700 px-1.5 py-0.5 rounded-full font-medium">
                                        {money(c.deposito_asignado)}
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div className="text-xs text-slate-500 bg-white/60 p-2 rounded-lg">
                        Esta empresa aún no tiene clientes.
                    </div>
                )}
            </div>
        </div>
    );
}